module.exports = "/assets/bees-unhealthy.png";